// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Styled Components
import { StyledModalItem } from "../styles";

// #####################################################

const OtherModalItem = ({
	close,
	handleChangeToOtherLocations,
	alwaysLight,
}) => {
	const { t } = useTranslation(["common"]);

	// #####################################################

	return (
		<StyledModalItem
			label="other"
			onClick={() => {
				handleChangeToOtherLocations();
				close();
			}}
			alwaysLight={alwaysLight}
		>
			{t("common:other")}
		</StyledModalItem>
	);
};

// #####################################################

export default OtherModalItem;

// #####################################################
